import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { QrRepairTaskSendDto, RepairTaskMailDraftDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-qr-repair-task-mail-dialog',
  templateUrl: './qr-repair-task-mail-dialog.component.html',
  styleUrls: ['./qr-repair-task-mail-dialog.component.scss'],
})
export class QrRepairTaskMailDialogComponent implements OnInit {
  @Input()
  draft?: RepairTaskMailDraftDto;

  readonly form = new FormGroup({
    subject: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    recipients: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    body: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  });

  ngOnInit(): void {
    this.form.setValue({
      subject: this.draft?.subject ?? '',
      recipients: (this.draft?.recipients ?? []).join(', '),
      body: this.draft?.htmlBody ?? '',
    });
  }

  get attachmentCount(): number {
    return this.draft?.photoCount ?? 0;
  }

  submitResponse = (): QrRepairTaskSendDto | false => {
    const recipients = this.form.controls.recipients.value
      .split(/[,;\s]+/)
      .map(it => it.trim())
      .filter(it => it.length > 0);
    if (this.form.invalid || recipients.length === 0) {
      return false;
    }
    return {
      subject: this.form.controls.subject.value.trim(),
      htmlBody: this.form.controls.body.value,
      recipients,
    };
  };
}
